<template>
  <div class="period-inner">
    <div class="step-title-row">
      <div class="step-title inline-block">보관 구독 기간</div>
      <div class="float-right">
        <div class="guide">
          기간별 월 결제요금 TIP

          <Popover dir="left" refKey="popover-price">
            <template #trigger>
              <button class="btn btn-icon">
                <i class="xi-help"></i>
              </button>
            </template>
            <div class="popover-content">
              <div class="price-tip-guide text-right">
                1개월 ~ 5개월 월 5,000원/박스<br>
                6개월 ~ 11개월 월 3,330원/박스<br>
                12개월 월 2,500원/박스
              </div>
            </div>
          </Popover>
        </div>
      </div>
    </div>
    <TheRulerSelect ref="ruler" :disabled="disabled" v-model="valueFromParent"/>

    <p class="ruler-guide tablet-hide">위치를 움직여 기간별로<br>더욱 커지는 할인금액을 확인해보세요!</p>

    <div class="arrow-row flex-center">
      <i class="xi-arrow-left"></i>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <i class="xi-arrow-right"></i>
    </div>

    <slot></slot>
  </div>
</template>

<script>
import TheRulerSelect from "@/components/TheRulerSelect";
import Popover from "@/components/Popover";

export default {
  name: "StoragePeriodV2",
  components: {
    TheRulerSelect,
    Popover
  },
  computed: {
    valueFromParent: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.$emit('update:modelValue', newValue);
      }
    }
  },
  // data() {
  //   return {
  //     period: 6
  //   }
  // },
  props: ['modelValue', 'disabled'],
  emits: ['update:modelValue'],
  methods: {
    moveUpdate(moveUpdate) {
      this.$refs.ruler.moveUpdate(moveUpdate);
    }
  }
  // watch() {
  //   'period': {
  //
  //   }
  // }
}
</script>

<style lang="scss" scoped>
    .step-title {
      font-size: 23px;
      line-height: 34px;
      font-weight: 900;
      letter-spacing: -0.23px;
    }


    .guide {
      color: #7F7F7F;
      font-size: 13px;
      line-height: 19px;
      font-weight: bold;
      padding-top: 15px;

      button {
        vertical-align: top;
        background: none;
      }

      i {
        color: $main-color;
        font-size: 17px;
        vertical-align: top;
        padding-top: 1px;
      }
    }

    .ruler-guide {
      color: #B4B7BE;
      font-size: 15px;
      line-height: 23px;
      text-align: center;
      font-weight: bold;
    }

    .arrow-row {
      color: #B4B7BE;
      font-size: 20px;
      font-weight: 300;

      > * {
        display: inline-block;
      }

      i:nth-of-type(1) {
        margin-right: 14px;
      }
      i:last-child {
        margin-left: 14px;
      }

      .dot {
        width: 2px;
        height: 2px;
        border-radius: 100%;
        background-color: #B4B7BE;

        &:nth-of-type(2) {
          margin: 0 8px;
        }
      }
    }

    @include respond(tablet) {
      .step-title {
        font-size: 18px;
        line-height: 26px;
        letter-spacing: -0.18px;
      }
      .guide {
        font-size: 10px;
        line-height: 15px;
        padding-top: 8px;

        i {
          font-size: 14px;
        }
      }

      .arrow-row {
        font-size: 13px;

        i:nth-of-type(1) {
          margin-right: 11px;
        }
        i:last-child {
          margin-left: 11px;
        }

        .dot:nth-of-type(2) {
          margin: 0 6px;
        }
      }
    }

</style>
<style lang="scss">
.period-inner {
  .price-tip-guide {
    white-space: nowrap;
  }

  .ruler-container {
    margin-top: 50px;
  }

  @include respond(tablet) {
    .ruler-container {
      margin-top: 30px;
      height: 105px;

      .highlight-row .highlight {
        margin-left: -12px;
        top: -12px;

        img {
          width: 24px;
        }
      }
    }
  }

  @include respond(sm-height-tablet) {
    .ruler-container {
      margin-top: 20px;
      height: 95px;
    }
  }
}
</style>
